const activity = {
  activity: "Veikla", // translated 
  activities: "Veikla", // translated 
  dates: "datos", // translated 
  location: "Vieta", // translated 
  languages: "Kalbos", // translated 
  categories: "Kategorijos", // translated 
  ticketOption: "Bilieto variantas", // translated 
  numberOfRatings: "Įvertinimų skaičius", // translated 
  meetingPointInfo: "Informacija apie susitikimo vietą", // translated 
  meetingPoint: "Susitikimo vieta", // translated 
  meetingPoints: "Susitikimo taškai", // translated 
  providedBy: "Pateikė", // translated 
  expirationDate: "Galiojimo laikas", // translated 
  groupSize: "Grupės dydis", // translated 
  features: "funkcijos", // translated 
  basedOn: "Remiantis", // translated 
  reviewsFromVerCustomers: "patvirtintų klientų atsiliepimai", // translated 
  excellent: "puikiai", // translated 
  great: "puiku", // translated 
  average: "vidutinis", // translated 
  poor: "vargšas", // translated 
  bad: "blogai", // translated 
  onlyBookedCustomersTooltip:
    "Tik klientai, kurie užsisakė šią veiklą, gali palikti atsiliepimą", // translated 
  noReviewsYet: "Šiuo metu atsiliepimų apie šią veiklą nėra.", // translated 
  backToActivitiesList: "Grįžti į veiklų sąrašą", // translated 
  getPrices: "gauti kainas", // translated 
  availabilityAndPrices: "Prieinamumas ir kainos", // translated 
  ticketOptions: "Bilietų parinktys", // translated 
  ticketInfo: "Informacija apie bilietus", // translated 
  selectYourTickets: "Pasirinkite savo bilietus", // translated 
  product: "Produktas", // translated 
  total: "Iš viso", // translated 
  slot: "Lizdas", // translated 
  language: "Kalba", // translated 
  tickets: "Bilietai", // translated 
  ticketsFor: "Bilietai Už", // translated 
  previousStep: "Ankstesnis žingsnis", // translated 
  onlyAvailableInEnglish: "Galima tik anglų kalba", // translated 
  guest: "Svečias", // translated 
  leadGuest: "Pagrindinis svečias", // translated 
  adult: "Suaugęs", // translated 
  child: "Vaikas", // translated 
  pleaseSelectAdult: "Pasirinkite bent vieną suaugusįjį", // translated 
  notAvailableActivity: "Šio produkto nėra", // translated 
  required: "Privaloma", // translated 
  pickupPoint: "Paėmimo taškas", // translated 
  pickupPoints: "Paėmimo taškai", // translated 
  ticketType: "Bilieto tipas", // translated 
  anonymous: "Anoniminis", // translated 
  printedVoucher: "Priimamas atspausdintas kuponas", // translated 
  mobileVoucher: "Mobilusis kuponas priimtas", // translated 
  mixedVoucher: "Priimamas mobilusis arba spausdintas kuponas", // translated 
  safetyMeasures: "Taikytos saugos priemonės", // translated 
  doThisBecause: "Daryk tai, nes", // translated 
  safetyInfo: "Saugos informacija", // translated 
  reviewsHighestFirst: "Atsiliepimų skaičius (pirmiausia aukščiausia)", // translated 
  bookingFee: "Rezervacijos mokestis", // translated 
  startDate: "Pradžios data", // translated 
  endDate: "Pabaigos data", // translated 
  cancellationDeadlineAndFees: "Atšaukimo terminas ir mokesčiai", // translated 
  resetTickets: "Iš naujo nustatyti bilietus", // translated 
  instantConfirmation: "Momentinis patvirtinimas", // translated 
  clickResetBtn: "Spustelėkite nustatymo iš naujo mygtuką, kad vėl pradėtumėte pasirinkimą", // translated 
  whatToRemember: "Ką prisiminti", // translated 
};



export default activity;
